/* eslint-disable prettier/prettier */
export const TYPES = {
  ADD_CARATERIZACION: 'ADD_CARATERIZACION',
  ADD_CARATERIZACION_SUCCESS: 'ADD_CARATERIZACION_SUCCESS',
  ADD_CARATERIZACION_ERROR: 'ADD_CARATERIZACION_ERROR',
  OBTENER_CARATERIZACION: 'OBTENER_CARATERIZACION',
  OBTENER_CARATERIZACION_SUCCESS: 'OBTENER_CARATERIZACION_SUCCESS',
  OBTENER_CARATERIZACION_ERROR: 'OBTENER_CARATERIZACION_ERROR',
  OBTENER_CARATERIZACION_EDITAR: 'OBTENER_CARATERIZACION_EDITAR',
  EDITAR_CARATERIZACION: 'EDITAR_CARATERIZACION',
  EDITAR_CARATERIZACION_SUCCESS: 'EDITAR_CARATERIZACION_SUCCESS',
  EDITAR_CARATERIZACION_ERROR: 'EDITAR_CARATERIZACION_ERROR',
  ACTIVAR_CARATERIZACION: 'ACTIVAR_CARATERIZACION',
  ACTIVAR_CARATERIZACION_SUCCESS: 'ACTIVAR_CARATERIZACION_SUCCESS',
  DELETE_CARATERIZACION: 'DELETECARATERIZACION',
  DELETE_CARATERIZACION_SUCCESS: 'DELETE_CARATERIZACION_SUCCESS',
  DELETE_CARATERIZACION_ERROR: 'DELETE_CARATERIZACION_ERROR',
}

export default TYPES
